import { FC } from 'react'
import Icon from 'public/img/icons/split-packman.svg'
import styles from './medpoint-ya-bage.module.scss'

interface IMedpointYaBage {
  price: number
}

const MedpointYaBage: FC<IMedpointYaBage> = ({ price }) => {
  const DELIMETR = 4
  return (
    <div className={styles.wrapper}>
      <div className={styles.price}>
        <Icon />
        {price / DELIMETR} ₽
      </div>
      <div>x {DELIMETR} платежа в Сплит</div>
    </div>
  )
}

export default MedpointYaBage
